export interface BlogPost {
  slug: string
  title: string
  date: string
  author: string
  summary: string
  content: string
  tags: string[]
}

export const blogPosts: BlogPost[] = []
